import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CerberusProvider } from "./hooks/useCerberus";
import APIErrorProvider from "./common/providers/APIErrorProvider";
import { ApiErrorNotification } from "./components/ApiErrorNotification/ApiErrorNotification";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./api/queryClient";
import { LoadingBackdrop } from "./components/LoadingBackdrop/LoadingBackdrop";
import APILoadingProvider from "./common/providers/APILoadingProvider";
import AlertProvider from "./common/providers/AlertProvider";
import { AlertNotification } from "./components/Alert/AlertNotification";
import { applyBrandHead } from "./branding/applyBrandHead";

// Apply brand title/favicon/theme-color/manifest before the app mounts.
applyBrandHead();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <CerberusProvider>
      <AlertProvider>
        <APIErrorProvider>
          <QueryClientProvider client={queryClient}>
            <APILoadingProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <App />
                <AlertNotification />
                <ApiErrorNotification />
                <LoadingBackdrop />
              </LocalizationProvider>
            </APILoadingProvider>
          </QueryClientProvider>
        </APIErrorProvider>
      </AlertProvider>
    </CerberusProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
